import { render } from "./content-list-view.vue?vue&type=template&id=ab05f252&scoped=true"
import script from "./content-list-view.vue?vue&type=script&lang=js"
export * from "./content-list-view.vue?vue&type=script&lang=js"

import "./content-list-view.vue?vue&type=style&index=0&id=ab05f252&scoped=true&lang=css"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab05f252"]])

export default __exports__